module.exports = __webpack_public_path__ + "img/it_01.9b5630ad.jpg";